export default "__VITE_ASSET__CG8FazW2__"